import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Text } from '@components/typography';
import { styled } from '@styledComponents';
import { JoykitColor } from '@components/themes';
import ReactHtmlParser from 'react-html-parser';

export const TextWrapper = styled.div`
  position: relative;
`;

export const StyledText = styled(Text)<{ shouldType: boolean }>`
  line-height: 46px !important;
  font-size: 24px;

  @keyframes blinkEffect {
    50% {
      opacity: 0;
    }
  }

  ::after {
    content: ' |';
    animation: blinkEffect 1s linear infinite;
  }
`;

const SPEED = 20;

interface TypewriterProps {
  onClick?: () => void;
  fullText: string;
  color: JoykitColor;
}

export const Typewriter: React.FC<TypewriterProps> = ({ onClick, color, fullText }) => {
  const [counter, setCounter] = useState(0);
  const [typedText, setTypedText] = useState('');
  const [shouldType, setShouldType] = useState(true);

  const typeWriter = useCallback(() => {
    if (!shouldType) {
      setTypedText(fullText);
    } else {
      if (fullText && counter < fullText.length) {
        const nextChar = fullText.charAt(counter);

        if (nextChar === '<') {
          setTypedText(fullText.slice(0, counter + 5));
          setTimeout(() => setCounter(counter + 5), SPEED);
        } else {
          setTypedText((currentText) => currentText + nextChar);
          setTimeout(() => setCounter(counter + 1), SPEED);
        }
      }
    }
  }, [counter, fullText, shouldType]);

  useEffect(() => typeWriter(), [fullText, typeWriter]);

  return (
    <TextWrapper onDoubleClick={() => setShouldType(false)} onClick={onClick}>
      <StyledText tagName="span" variant="hed40" color={color} shouldType={shouldType}>
        {ReactHtmlParser(typedText)}
      </StyledText>
    </TextWrapper>
  );
};
